import { get, post, put, putWithHeaders, destroy } from '@/api/request';

function fetchUsers(params) {
  return get('/users', params);
}

function fetchSingleUser({ id }) {
  return get(`/users/${id}`);
}

function register(data) {
  return post('/auth', data);
}

function login(data) {
  return post('/auth/sign_in', data);
}

function logout() {
  return destroy('/auth/sign_out');
}

function validateToken(params) {
  return get('/auth/validate_token', params);
}

function updateAccount(data) {
  if (data.password === '') {
    delete data.password;
    delete data.password_confirmation;
  }
  return put('/auth', data);
}

function sendPasswordReset(data) {
  return post('/auth/password', data);
}

function updatePassword(data) {
  const { 'access-token': accessToken, uid, client, ...body } = data;
  return putWithHeaders('/auth/password', body, {
    'access-token': accessToken,
    uid,
    client,
  });
}

function createUser(data) {
  return post('/users', data);
}

function onboardUser(data) {
  return post('/users/onboard', data);
}

function updateUser({ id, data }) {
  return put(`/users/${id}`, data);
}

function deleteUser(id) {
  return destroy(`/users/${id}`);
}

function allocateInitialTimeoff(id) {
  return post(`/users/${id}/allocate_initial_timeoff`);
}

function reallocatePto(id) {
  return post(`/users/${id}/reallocate_pto`);
}

function setPtoApprover({ id, enabled }) {
  return put(`/users/${id}/permissions/pto_approver`, { enabled });
}

function getCurrentUser() {
  return get('/users/get_current_user');
}

export default {
  fetchUsers,
  fetchSingleUser,
  register,
  login,
  getCurrentUser,
  logout,
  validateToken,
  updateAccount,
  sendPasswordReset,
  updatePassword,
  createUser,
  onboardUser,
  updateUser,
  deleteUser,
  allocateInitialTimeoff,
  reallocatePto,
  setPtoApprover,
};



// WEBPACK FOOTER //
// ./src/store/modules/user/api.js